import { render, staticRenderFns } from "./UpdateUWStatusModal.vue?vue&type=template&id=87933eee&scoped=true&"
import script from "./UpdateUWStatusModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUWStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUWStatusModal.vue?vue&type=style&index=0&id=87933eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87933eee",
  null
  
)

export default component.exports